module.exports = __webpack_public_path__ + "img/red-3-squiggly-striped.2548b03c.svg";